const gonFeatures = window.gon?.features

/**
 * Returns true if the country is enabled for the given `gon` feature.
 */
export const useIsCountryEnabledForFeature = (
  gonFeatureName: keyof typeof gonFeatures,
  countryCode: string | null | undefined,
) => {
  if (!gonFeatures) {
    console.error("Gon flags not found")
    return false
  }
  const enabledCountries = gonFeatures[gonFeatureName]

  if (!enabledCountries || !Array.isArray(enabledCountries)) {
    console.error(`Country feature "${gonFeatureName}" not found`)
    return false
  }
  if (!countryCode) return false

  return enabledCountries.includes(countryCode)
}
